import Repository from "./Repository";

const CREATE_MEMBERSHIP = "create";
const UPDATE_MEMBERSHIP = "update";
const GET_MEMBERSHIP = "get";
const GET_ALL_MEMBERSHIP = "getall";
const DELETE_MEMBERSHIP = "delete";
const GET_ADMIN = "getAdmin";

export default {
  create_membership(payload) {
    return Repository.post(transformRoute(CREATE_MEMBERSHIP), payload);
  },
  update_membership(payload) {
    return Repository.post(transformRoute(UPDATE_MEMBERSHIP), payload);
  },
  get_membership(payload) {
    return Repository.post(transformRoute(GET_MEMBERSHIP), payload);
  },
  get_all_membership(payload) {
    return Repository.post(transformRoute(GET_ALL_MEMBERSHIP), payload);
  },
  get_membership_for_admin(payload) {
    return Repository.post(transformRoute(GET_ADMIN), payload);
  },
  delete_membership(payload) {
    return Repository.post(transformRoute(DELETE_MEMBERSHIP), payload);
  },
};

const transformRoute = (route) => {
  return `membership/${route}`;
};
